import React, { useContext } from 'react'
import { ContentFooter } from '../../../layout/Content'
import RecordNavigator from '../../../layout/RecordNavigator'
import POListFooterStyle from './css/POListFooterStyle'
import { poListControllerContext } from './POListController'

function POListFooter() {
  const poListController = useContext(poListControllerContext)
  const { getTotalRecords, totalPage } = poListController
  const [recordPerPage, setRecordPerPage] = poListController.recordPerPage
  const [recPP, setRecPP] = poListController.recPP
  const [page, setPage] = poListController.page

  const recordNavigatorProps = {
    recPP: [recPP, setRecPP],
    page: [page, setPage],
    recordPerPage: [recordPerPage, setRecordPerPage],
    totalPage, getTotalRecords
  }

  return (
    <ContentFooter>
      <div id="po-list-footer-container">
        <RecordNavigator { ...recordNavigatorProps } />
      </div>
      <POListFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(POListFooter)
